import { Directive, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';

import { HashTriggerable } from '@finder/shared/features/hash-triggerable/hash-triggerable-base';
import { HashTriggerableService } from '@finder/shared/features/hash-triggerable/hash-triggerable.service';
import { CampaignDrawerOpen } from '@finder/shared/services/campaign-drawer/campaign-drawer.interface';
import { CampaignDrawerService } from '@finder/shared/services/campaign-drawer/campaign-drawer.service';

@Directive()
export abstract class CampaignDrawerBase extends HashTriggerable implements OnInit {
    constructor(
        protected hashTriggerableService: HashTriggerableService,
        protected route: ActivatedRoute,
        protected drawerService: CampaignDrawerService,
    ) {
        super(hashTriggerableService, route);

        this.drawerService.open
            .pipe(
                filter(data =>  data !== null), // Skip the intial one
                takeUntil(this.destroy$)
            )
            .subscribe(data => this.onOpen(data));
    }

    ngOnInit(): void {
        this.hashTriggerableService.getActiveElementId()
            .pipe(
                filter(result => result !== void 0), // First one is undefined
                takeUntil(this.destroy$)
            )
            .subscribe(result => {
                if (result === null || result !== this.elementId) {
                    this.collapse();
                } else {
                    this.expand();
                }
            });
    }

    protected abstract onOpen(data: CampaignDrawerOpen);

    protected abstract setOpen();
}
